import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@guildeducationinc/recess';
import { PaymentRequest } from '@src/components/PaymentRequest';
import { useLocale } from 'pe-core-frontend';
import { useParams } from 'react-router-dom';
export const PaymentRequestClaim = () => {
    const { t } = useLocale();
    const { id } = useParams();
    if (!id || isNaN(parseInt(id, 10))) {
        return (_jsx("div", { children: _jsx(Alert, { display: true, hideClose: true, type: 'danger', children: t('Invalid claim') }) }));
    }
    return (_jsx("div", { children: _jsx(PaymentRequest, { id: parseInt(id, 10) }) }));
};
